var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "8064c5bb0ee75ac910ed7b23c71e639672eec4bb"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "8064c5bb0ee75ac910ed7b23c71e639672eec4bb"
};